import FileDownload from 'react-file-download';
import { toast } from 'react-toastify';
import React from 'react';
import qs from 'qs';
import {
  GET_SCAN_LIST_PENDING,
  GET_SCAN_LIST_FETCHED,
  GET_SCAN_LIST_REJECTED,
  GET_SCAN_PENDING,
  GET_SCAN_REJECTED,
  GET_SCAN_FETCHED,
  PATCH_REVERSE_SCAN_PENDING,
  PATCH_REVERSE_SCAN_FULFILLED,
  PATCH_REVERSE_SCAN_REJECTED,
  GET_DAMAGED_BARCODE_SUBMISSION_LIST_PENDING,
  GET_DAMAGED_BARCODE_SUBMISSION_LIST_FETCHED,
  GET_DAMAGED_BARCODE_SUBMISSION_LIST_REJECTED,
  GET_SCAN_OVERRIDE_LIST_PENDING,
  GET_SCAN_OVERRIDE_LIST_FETCHED,
  GET_SCAN_OVERRIDE_LIST_REJECTED,
  PATCH_DECLINE_SCAN_OVERRIDE_PENDING,
  PATCH_DECLINE_SCAN_OVERRIDE_FULFULLED,
  PATCH_DECLINE_SCAN_OVERRIDE_REJECTED,
  APPROVE_SCAN_OVERRIDE_PENDING,
  APPROVE_SCAN_OVERRIDE_FULFILLED,
  APPROVE_SCAN_OVERRIDE_REJECTED
} from '../reducers/scansReducer';
import api from '../irelandApi';
import ToastMessage from '../components/common/toast-message';
import { history } from '../store';

const SCANS_URL = '/api/admin/scans';

// eslint-disable-next-line import/prefer-default-export
export const getScans = (query, valid, invalid, failReason, dateFrom, dateTo, page = 1) => (dispatch) => {
  dispatch({ type: GET_SCAN_LIST_PENDING });

  const q = {
    query,
    valid,
    invalid,
    fail_reason: failReason,
    date_from: dateFrom,
    date_to: dateTo,
  };

  return api.get(`${SCANS_URL}?${qs.stringify({q}, {encodeValuesOnly: true})}&page=${page}`)
    .then((response) => {
      dispatch({
        type: GET_SCAN_LIST_FETCHED,
        payload: response.data
      });
    })
    .catch((error) => {
      dispatch({
        type: GET_SCAN_LIST_REJECTED,
        payload: error.response
      });
    });
};

export const getScansCsv = (query, valid, invalid, failReason, dateFrom, dateTo) => {
  const q = {
    query,
    valid,
    invalid,
    fail_reason: failReason,
    date_from: dateFrom,
    date_to: dateTo,
  };

  return api.get(`${SCANS_URL}.csv?${qs.stringify({q}, {encodeValuesOnly: true})}`)
    .then((response) => {
      const filename = 'scans.csv';
      FileDownload(response.data, filename);
    })
    .catch((error) => {
      toast.error(<ToastMessage iconStyle="error" message={`Scans can not be downloaded: ${error.response.data.errors[0]}`}/>);
    });
};

export const getScan = id => (dispatch) => {
  dispatch({ type: GET_SCAN_PENDING });

  return api.get(`${SCANS_URL}/${id}`)
    .then((response) => {
      dispatch({
        type: GET_SCAN_FETCHED,
        payload: response.data
      });
    })
    .catch((error) => {
      dispatch({
        type: GET_SCAN_REJECTED,
        payload: error
      });
    });
};

export const reverseScan = id => (dispatch) => {
  dispatch({ type: PATCH_REVERSE_SCAN_PENDING });

  return api.patch(`${SCANS_URL}/${id}/reverse_scan`)
    .then((response) => {
      dispatch({
        type: PATCH_REVERSE_SCAN_FULFILLED,
        payload: response.data
      });
    })
    .catch((error) => {
      dispatch({
        type: PATCH_REVERSE_SCAN_REJECTED,
        payload: error.response
      });
    });
};

export const getDamagedBarcodeSubmissions = (query, status, page = 1) => (dispatch) => {
  dispatch({ type: GET_DAMAGED_BARCODE_SUBMISSION_LIST_PENDING });

  const q = {
    query,
    status
  };

  return api.get(`${SCANS_URL}/damaged_barcode_submissions?${qs.stringify({ q }, { encodeValuesOnly: true })}&page=${page}`)
    .then((response) => {
      dispatch({
        type: GET_DAMAGED_BARCODE_SUBMISSION_LIST_FETCHED,
        payload: response.data
      });
    })
    .catch((error) => {
      dispatch({
        type: GET_DAMAGED_BARCODE_SUBMISSION_LIST_REJECTED,
        payload: error.response
      });
    });
};

export const approveDamagedBarcodeSubmission = (id, payload) => () => {
  const q = { ...payload };

  return api.patch(`${SCANS_URL}/${id}/approve_damaged_barcode_submission?${qs.stringify({ q }, { encodeValuesOnly: true })}`)
    .then((response) => {
      const message = response.data.data.attributes['fail-reason'] === 'duplicate' ?
        'Duplicated Damaged Barcode Submission declined successfully' :
        'Damaged Barcode Submission approved successfully';

      toast.success(<ToastMessage iconStyle="success" message={message} />);
      history.push('/admin/scans/damaged-barcode-submissions');
    })
    .catch(() => {
      toast.error(<ToastMessage iconStyle="error" message="An error occurred during approve" />);
    });
};

export const declineDamagedBarcodeSubmission = (id, payload) => () => {
  const q = { ...payload };

  return api.patch(`${SCANS_URL}/${id}/decline_damaged_barcode_submission?${qs.stringify({ q }, { encodeValuesOnly: true })}`)
    .then(() => {
      toast.success(<ToastMessage iconStyle="success" message="Damaged Barcode Submission declined successfully" />);
      history.push('/admin/scans/damaged-barcode-submissions');
    })
    .catch(() => {
      toast.error(<ToastMessage iconStyle="error" message="An error occurred during decline" />);
    });
};

export const getScanOverrides = (query, overrideRequestStatus, overrideRequestDateFrom, overrideRequestDateTo, page = 1) => (dispatch) => {
  dispatch({ type: GET_SCAN_OVERRIDE_LIST_PENDING });

  const q = {
    query,
    override_request_status: overrideRequestStatus,
    override_request_date_from: overrideRequestDateFrom,
    override_request_date_to: overrideRequestDateTo,
  };

  return api.get(`${SCANS_URL}/scan_overrides?${qs.stringify({q}, {encodeValuesOnly: true})}&page=${page}`)
    .then((response) => {
      dispatch({
        type: GET_SCAN_OVERRIDE_LIST_FETCHED,
        payload: response.data
      });
    })
    .catch((error) => {
      dispatch({
        type: GET_SCAN_OVERRIDE_LIST_REJECTED,
        payload: error.response
      });
    });
};

export const declineScanOverride = (id, payload) => (dispatch) => {
  dispatch({ type: PATCH_DECLINE_SCAN_OVERRIDE_PENDING });

  const q = { ...payload };

  return api.patch(`${SCANS_URL}/${id}/decline_scan_override?${qs.stringify({ q }, { encodeValuesOnly: true })}`)
    .then((response) => {
      dispatch({
        type: PATCH_DECLINE_SCAN_OVERRIDE_FULFULLED,
        payload: response.data
      });
      toast.success(<ToastMessage iconStyle="success" message="Scan Override declined successfully" />);
    })
    .catch((error) => {
      dispatch({
        type: PATCH_DECLINE_SCAN_OVERRIDE_REJECTED,
        payload: error.response
      });
      toast.error(<ToastMessage iconStyle="error" message="An error occurred during decline" />);
    });
};

export const approveScanOverride = id => (dispatch) => {
  dispatch({ type: APPROVE_SCAN_OVERRIDE_PENDING });

  return api.patch(`${SCANS_URL}/${id}/approve_scan_override`)
    .then((response) => {
      toast.success(<ToastMessage iconStyle="success" message="Scan overrode request approved" />);
      dispatch({
        type: APPROVE_SCAN_OVERRIDE_FULFILLED,
        payload: response.data
      });
    })
    .catch((error) => {
      toast.error(<ToastMessage iconStyle="error" message="An error occurred during approve" />);
      dispatch({
        type: APPROVE_SCAN_OVERRIDE_REJECTED,
        payload: error.response
      });
    });
};



// WEBPACK FOOTER //
// ./src/actions/scans.js